import Splitting from 'splitting';

export function textSplit() {
    // Select all h1 elements
    const h1Elements = document.querySelectorAll('h1');

    h1Elements.forEach(h1 => {
        // Add a class to indicate splitting is in progress
        h1.classList.add('is-splitting');

        // Initialize Splitting.js with word splitting
        Splitting({
            target: h1,
            by: 'words'
        });

        // After splitting, add the animated class to trigger the animation
        // and remove the splitting class
        requestAnimationFrame(() => {
            h1.classList.remove('is-splitting');
            h1.classList.add('splitting-done');
        });
    });
}
